var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_x30_1",
    fill: "white",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "injected-svg",
    "data-src": "/static/media/home.edd6b4dcd1eb7c4e922c1ffc5bd2fc6e.svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.284,227.716l-216-216c-15.621-15.621-40.948-15.621-56.568,0h0l-216,216c-15.621,15.621-15.621,40.948,0,56.568  C23.69,296.258,41.363,299.042,56,292.659V452c0,33.137,26.863,60,60,60h280c33.137,0,60-26.863,60-60V292.659  c14.637,6.383,32.31,3.599,44.284-8.375h0C515.905,268.663,515.905,243.337,500.284,227.716z M326,432c0,11.046-8.954,20-20,20H206  c-11.046,0-20-8.954-20-20V312c0-11.046,8.954-20,20-20h100c11.046,0,20,8.954,20,20V432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1ca398e1709fcd903cce2ca32f6e9069.svg";
export { ForwardRef as ReactComponent };